import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'finance',
    name: 'Finance',
    description: 'Ledger, receivables, payables, VAT and financial reporting.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'finance',
    features: [
        { key: 'finance.multi_currency', description: 'Transact and report in more than one currency' },
        { key: 'finance.consolidation', description: 'Consolidated reporting across legal entities' },
        { key: 'finance.e_invoicing', description: 'Structured electronic invoice exchange' },
    ],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user', 'legal_entity'] },
        {
            code: 'ed_02',
            description: 'Adds multi-currency',
            features: ['finance.multi_currency'],
            limits: ['user', 'legal_entity', 'transaction'],
        },
        {
            code: 'ed_03',
            description: 'Adds consolidation and electronic invoicing',
            features: ['finance.multi_currency', 'finance.consolidation', 'finance.e_invoicing'],
            limits: ['user', 'active_user', 'legal_entity', 'transaction'],
        },
    ],
    limitTypes: ['user', 'active_user', 'legal_entity', 'transaction'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'numbering',
        'money',
        'tax',
        'party_master',
        'procurement_kernel',
        'inventory',
    ],
    optionalModules: ['field-service', 'crm', 'projects'],
    integrationDeps: ['hmrc-mtd', 'banking-feed'],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map